// @ts-nocheck
export function pipe() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }
  return funcs.reduce((prevFunc, curFunc) => arg => curFunc(prevFunc(arg)));
}
export function set(key, value) {
  return obj => {
    obj[key] = value;
    return obj;
  };
}
export function softFail(func) {
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    try {
      return func(...args);
    } catch (err) {
      var _console;
      (_console = console) == null || _console.error == null || _console.error('Exception occurred while processing log message', args);
    }
  };
}
//# sourceMappingURL=general.js.map